// src/pages/ServicesPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { PRODUCTS } from '../data/products';
import { OTHER_SERVICES, SERVICE_TONES } from '../data/otherServices';
import Reveal from '../components/layout/Reveal';
import { Breadcrumb, usePageTitle } from '../components/layout/PageBits';

const TABS = ['protect', 'invest', 'plan'];

function ServicesPage() {
  const { lang, t } = useLang();
  const [tab, setTab] = useState('protect');
  usePageTitle(t('allServices'));

  const cards = tab === 'protect'
    ? PRODUCTS.map((p) => ({ id: p.id, img: p.img, emoji: p.emoji, title: p[lang].title, text: p[lang].sub, soft: p.tone.soft, text2: p.tone.text }))
    : OTHER_SERVICES.filter((s) => s.group === tab && !s.hidden).map((s) => ({ id: s.id, emoji: s.emoji, title: s[lang].title, text: s[lang].desc, soft: SERVICE_TONES[s.tone].soft, text2: SERVICE_TONES[s.tone].text }));

  return (
    <section className="py-12 sm:py-16 bg-white min-h-[70vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Breadcrumb current={t('allServices')} />
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div><h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight">{t('svTitle')}</h1><p className="mt-3 text-slate-600 max-w-2xl">{t('svSub')}</p></div>
          <div className="inline-flex p-1 bg-slate-100 rounded-xl text-sm font-semibold self-start" role="tablist">
            {TABS.map((k) => (
              <button key={k} type="button" role="tab" aria-selected={tab === k} onClick={() => setTab(k)}
                className={`px-4 py-2 rounded-lg transition ${tab === k ? 'bg-white shadow text-ink' : 'text-slate-500'}`}>{t(`tab_${k}`)}</button>
            ))}
          </div>
        </div>
        <Reveal key={tab} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((c) => (
            <Link key={c.id} to={`/services/${c.id}`} className={`group rounded-3xl p-6 ${c.soft} transition hover:-translate-y-1 hover:shadow-xl`}>
              {c.img ? <img src={c.img} alt="" aria-hidden="true" loading="lazy" className="w-16 h-16 object-contain drop-shadow-md transition-transform group-hover:scale-110 origin-left" /> : <div className="text-4xl transition-transform group-hover:scale-110 origin-left" aria-hidden="true">{c.emoji}</div>}
              <h2 className="mt-4 text-xl font-extrabold">{c.title}</h2>
              <p className="mt-2 text-slate-600 text-[15px] leading-relaxed line-clamp-3">{c.text}</p>
              <span className={`mt-4 inline-block text-sm font-bold ${c.text2}`}>{t('more')}</span>
            </Link>
          ))}
        </Reveal>
      </div>
    </section>
  );
}

export default ServicesPage;
